import React, { ReactElement } from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { RouterBackoffice } from 'src/AppState/RouterBackoffice';
import { TabList, TabTrigger } from 'src/domains/common/components/tabs/tabs';
import { observer } from 'src/utils/mobx-react';

export type PromotionHistoryTabType = 'free-bets' | 'free-spins' | 'bonus-balance' | 'campaigns';

type TabType = {
    id: PromotionHistoryTabType;
    label: string;
    isDisabled: boolean;
};

const allTabs: Array<TabType> = [
    {
        id: 'free-bets',
        label: 'Free Bets',
        isDisabled: false,
    },
    {
        id: 'free-spins',
        label: 'Free spins',
        isDisabled: false,
    },
    {
        id: 'bonus-balance',
        label: 'Bonus Balance',
        isDisabled: false,
    },
    {
        id: 'campaigns',
        label: 'Campaigns',
        isDisabled: true,
    },
];

export const getActiveTabId = (routerBackoffice: RouterBackoffice): PromotionHistoryTabType => {
    const customerParams = routerBackoffice.getParametersString('customers', 'tab.tab.tab');

    switch (customerParams) {
        case 'free-bets':
            return 'free-bets';
        case 'free-spins':
            return 'free-spins';
        case 'bonus-balance':
            return 'bonus-balance';
        case 'campaigns':
            return 'campaigns';
        default:
            return 'free-bets';
    }
};

interface PromotionHistoryTabsPropsType {
    activeTabId: PromotionHistoryTabType;
}

export const PromotionHistoryTabs = observer(
    'PromotionHistoryTabs',
    (props: PromotionHistoryTabsPropsType): ReactElement => {
        const { routerBackoffice } = useAppStateContext();

        return (
            <TabList className='grid grid-cols-4'>
                {allTabs.map((tab) => (
                    <TabTrigger
                        key={tab.id}
                        onClick={() => routerBackoffice.redirectToCustomerPromotionHistoryTab(tab.id)}
                        active={props.activeTabId === tab.id}
                        disabled={tab.isDisabled}
                    >
                        {tab.label}
                    </TabTrigger>
                ))}
            </TabList>
        );
    }
);
